import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import DdButton from '~/components/DdButton.vue';
export default {
  __name: 'ShareButton',
  props: {
    anchor: {
      type: String,
      default: 'share-button'
    },
    name: {
      type: String,
      default: 'share'
    },
    exactActiveOnly: {
      type: Boolean,
      default: false
    },
    shareTitle: {
      type: String
    },
    text: {
      type: String
    },
    url: {
      type: String
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var appStore = useAppStore();
    var OS = computed(function () {
      return appStore.os;
    });
    var componentType = ref('button');

    // Ceck if share API not available or disabled fro OS
    onMounted(function () {
      if (!navigator.share || !['iOS', 'Android', 'Windows'].includes(OS.value)) {
        componentType.value = DdButton;
      }
    });
    var urlToShare = computed(function () {
      if (props.url) return props.url;
      return window ? window.location.href : '';
    });
    var textToShare = computed(function () {
      if (props.text) return props.text;
      var metaDescription = '';
      if (document) {
        var _document$querySelect;
        metaDescription = ((_document$querySelect = document.querySelector('meta[name="description"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('content')) || '';
      }
      return metaDescription;
    });
    function onClick(_x) {
      return _onClick.apply(this, arguments);
    }
    function _onClick() {
      _onClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(componentType.value !== 'button')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return navigator.share({
                title: props.shareTitle || document.title || 'CASES',
                // text: textToShare.value, // Disabled cuz iOS copy text only
                url: urlToShare.value
              });
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              console.log("Error: ".concat(_context.t0));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 7]]);
      }));
      return _onClick.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      appStore: appStore,
      OS: OS,
      componentType: componentType,
      urlToShare: urlToShare,
      textToShare: textToShare,
      onClick: onClick
    };
  }
};